(function() {
  function initDiamondShapesCarousel() {
    const containers = document.querySelectorAll('.diamond-shapes-carousel-container');
    if (containers.length === 0) return;

    containers.forEach(container => {
      initSingleCarousel(container);
    });
  }

  function initSingleCarousel(container) {
    const carousel = container.querySelector('.diamond-shapes-list');
    const items = Array.from(container.querySelectorAll('.diamond-shape-item'));
    const prevBtn = container.querySelector('.diamond-shapes-nav--prev');
    const nextBtn = container.querySelector('.diamond-shapes-nav--next');
    const activeLabel = container.querySelector('.diamond-shapes-active');

    if (!carousel || items.length === 0) return;

    // Check if this is for earrings (Prong Type) or diamond shapes
    const isEarrings = container.querySelector('.diamond-shapes-label')?.textContent.includes('PRONG TYPE');
    
    const shapeNames = isEarrings ? {
      'stud': 'STUD',
      'hoop': 'HOOP',
      'huggies': 'HUGGIES',
      'drop': 'DROP',
      'halo': 'HALO',
      'bezel': 'BEZEL',
      'cluster': 'CLUSTER',
      'nature': 'NATURE',
      'single': 'SINGLE',
      'statement': 'STATEMENT',
      'climbers': 'CLIMBERS'
    } : {
      'round': 'ROUND',
      'oval': 'OVAL',
      'cushion': 'CUSHION',
      'pear': 'PEAR',
      'marquise': 'MARQUISE',
      'emerald': 'EMERALD',
      'radiant': 'RADIANT',
      'asscher': 'ASSCHER',
      'princess': 'PRINCESS'
    };

    let currentIndex = 0;
    const itemsPerView = window.innerWidth <= 767 ? 3 : 6;
    const maxIndex = Math.max(0, items.length - itemsPerView);

    function updateActiveShape(shape) {
      items.forEach(item => item.classList.remove('active'));
      const activeItem = items.find(item => item.dataset.shape === shape);
      if (activeItem) {
        activeItem.classList.add('active');
        if (activeLabel) {
          activeLabel.textContent = shapeNames[shape] || shape.toUpperCase();
        }
      }
    }

    function updateCarousel() {
      const itemWidth = 80; // Fixed width
      const gap = 15;
      const translateX = -currentIndex * (itemWidth + gap);
      carousel.style.transform = `translateX(${translateX}px)`;

      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;
    }

    function scrollToIndex(index) {
      currentIndex = Math.max(0, Math.min(index, maxIndex));
      updateCarousel();
    }

    // Click handlers for shape items
    items.forEach((item, index) => {
      item.addEventListener('click', function() {
        const shape = this.dataset.shape;
        updateActiveShape(shape);
      });
    });

    // Navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToIndex(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToIndex(currentIndex + 1);
      });
    }

    // Initialize
    updateCarousel();
    const defaultShape = isEarrings ? 'stud' : 'round';
    updateActiveShape(defaultShape);

    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const newItemsPerView = window.innerWidth <= 767 ? 3 : 6;
        const newMaxIndex = Math.max(0, items.length - newItemsPerView);
        if (currentIndex > newMaxIndex) {
          currentIndex = newMaxIndex;
        }
        updateCarousel();
      }, 250);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiamondShapesCarousel);
  } else {
    initDiamondShapesCarousel();
  }

    // Re-initialize for theme editor
    document.addEventListener('shopify:section:load', function(event) {
      const containers = event.target.querySelectorAll ? event.target.querySelectorAll('.diamond-shapes-carousel-container') : [];
      containers.forEach(container => {
        initSingleCarousel(container);
      });
    });
})();

